@if (isMedCaseLayout) {
  <div class="med-case-file w-full mb-4">
    @if (stampLocationVisible && showUploadInput) {
      <div class="field-control mt-2">
        <app-option-field
          [label]="'DOCUMENTS.STAMP_LOC' | translate"
          [options]="stampPositions"
          [control]="stampLocationControl"
          [labelKey]="'label'"
          [valueKey]="'value'"
        ></app-option-field>
      </div>
    }
    <div class="mb-9">
      @if (showAction && showUploadInput) {
        <div class="med-case-upload-wrap mt-2">
          <input
            #fileInput
            [id]="uploadInputId"
            type="file"
            (change)="onFileChange($event)"
            [disabled]="isUploading"
            class="med-case-hidden-input"
          />
          <label
            [for]="uploadInputId"
            class="med-case-upload-trigger"
            [class.disabled]="isUploading"
          >
            <span class="med-case-upload-icon" aria-hidden="true">
              <img src="/icons/svg/Upload.svg" alt="" />
            </span>
            <span class="med-case-upload-copy">
              <span class="med-case-upload-title">{{
                "DOCUMENTS.UPLOAD_FILE" | translate
              }}</span>
              <span class="med-case-upload-note">{{ "DOCUMENTS.PDF_FORMAT" | translate}}</span>
            </span>
          </label>
        </div>
      }

      @if (validationError == "DOCUMENTS.SELECT_STAMP_LOCATION") {
        <div class="fields-error-container mt-2">
          {{ "DOCUMENTS.SELECT_STAMP_LOCATION" | translate }}
        </div>
      } @else if (validationError || isDocumentsMissing) {
        <div class="fields-error-container mt-2">
          {{ validationError | translate }}
          @if (isDocumentsMissing) {
            {{ "DOCUMENTS.FILE_REQUIRED" | translate }}
          }
        </div>
      }
    </div>

    <div class="w-full mt-25">
      @for (attachment of medCaseDisplayAttachments; track attachment.documentId || attachment.name || $index) {
        <div class="med-case-item">
          <div class="med-case-item-head">
            <div class="med-case-item-left">
              <span class="med-case-doc-icon" aria-hidden="true">
                <img src="icons/svg/File.svg" />
              </span>
              <div class="med-case-item-text">
                <p class="med-case-item-title">{{ title }}</p>
                <!-- attachment._docTitle  -->
                @if (attachment?.documentId) {
                  <a
                    class="med-case-file-link"
                    (click)="downloadDocument(attachment)"
                    title="Click here to download file"
                    [class.pointer-events-none]="
                      downloadingId === attachment.documentId
                    "
                    [class.opacity-60]="downloadingId === attachment.documentId"
                  >
                    {{ attachment.name ? attachment._docTitle : attachment.label }}
                  </a>
                } @else {
                  <p class="med-case-meta-row">
                    {{ "DOCUMENTS.FILE_FORMAT_LABEL" | translate }}:
                    {{ getAttachmentFormat(attachment) || "-" }}
                    <span class="med-case-meta-gap">
                      {{ "DOCUMENTS.FILE_SIZE_LABEL" | translate }}:
                      {{ getAttachmentSize(attachment) || "-" }}
                    </span>
                  </p>
                }
              </div>
            </div>

            @if (showAction && attachment.documentId && attachment?.canDelete) {
              @if (!attachment?.memberFolderId) {
                <button
                  type="button"
                  (click)="onRemove(attachment)"
                  [disabled]="isRemoving"
                  class="med-case-remove-link"
                >
                  {{ "DOCUMENTS.REMOVE" | translate }}
                </button>
              }
            } @else if (showAction && !attachment.documentId) {
              <!-- <span class="med-case-remove-link">Cancel</span> -->
            }
          </div>

          <div class="med-case-progress-row">
            <div class="med-case-progress-track">
              <div
                class="med-case-progress-fill"
                [style.width.%]="getProgressPercent(attachment)"
              ></div>
            </div>
            @if (attachment?.uploaded || attachment?.documentId) {
              <!-- <span class="med-case-progress-check" aria-hidden="true">&#10003;</span> -->
              <img src="/icons/svg/file-success.svg" />
            }
          </div>

          @if (downloadingId == attachment?.documentId) {
            <span class="text-left">
              <app-skeleton-loader [pingLoder]="true"></app-skeleton-loader>
            </span>
          }
        </div>
      }
    </div>

  </div>
} @else {
  <div class="w-full mb-4">
    <div class="col-span-3">
      <label class="field-label !text-dc-black-light">{{ title }}</label>
      @if (description) {
        <p class="text-sm text-gray-600 mb-0.5">
          {{ description }}
        </p>
      }

      <span class="attachmennt-fromat-line">
        {{ "DOCUMENTS.FILE_SIZE" | translate }}
      </span>
      @if (documentServiceType == "template") {
        <span class="attachmennt-fromat-line">
          {{ "DOCUMENTS.FILE_FORMAT_TEMPLATE" | translate : { format: templateFormatLabel } }}
        </span>
      } @else {
        <span class="attachmennt-fromat-line">
          {{ "DOCUMENTS.FILE_FORMAT_ALLOWED" | translate : { format: allowedFormatLabel } }}
        </span>
      }

      @if (stampLocationVisible) {
        <div class="field-control mt-2">
          <app-option-field
            [label]="'DOCUMENTS.STAMP_LOC' | translate"
            [options]="stampPositions"
            [control]="stampLocationControl"
            [labelKey]="'label'"
            [valueKey]="'value'"
          ></app-option-field>
        </div>
      }
    </div>

    @for (attachment of attachments; track attachment) {
      <div class="lg:grid lg:grid-cols-4 mt-4">
        <div class="col-span-2 flex items-center gap-2">
          <a
            class="text-dc-dark-blue underline underline-offset-4 font-semibold text-sm"
            (click)="downloadDocument(attachment)"
            title="Click here to download file"
            [class.pointer-events-none]="
              downloadingId === attachment.documentId
            "
            [class.opacity-60]="downloadingId === attachment.documentId"
            >{{ attachment.name ? attachment.name : attachment.label }}
          </a>
          <span class="text-left">
            @if (downloadingId == attachment?.documentId) {
              <app-skeleton-loader [pingLoder]="true"></app-skeleton-loader>
            }
          </span>
        </div>

        <div class="flex items-center gap-4 mt-2">
          @if (!attachment.uploaded && attachment.progress) {
            <div
              class="w-full h-2 bg-gray-200 rounded relative overflow-hidden"
            >
              <div
                class="absolute left-0 top-0 h-full bg-[#003366] transition-all duration-300"
                [style.width.%]="attachment.progress"
              ></div>
            </div>
          }
          @if (attachment?.uploaded || attachment.documentId) {
            <span class="bg-[#CCEBD6] text-dc-black text-sm px-3 py-1">
              {{ "DOCUMENTS.UPLOADED" | translate }}
            </span>
          }
          @if (showAction && attachment.documentId && attachment?.canDelete) {
            @if (!attachment?.memberFolderId) {
              <button
                (click)="onRemove(attachment)"
                [disabled]="isRemoving"
                class=""
                [ngClass]="isRemoving ? 'text-gray-300':'text-dc-dark-blue underline underline-offset-4 text-sm'"
               >
                {{ "DOCUMENTS.REMOVE" | translate }}
              </button>
            }
          }
        </div>
      </div>
    }

    @if (showAction && showUploadInput) {
      <div class="col-span-4">
        <div class="mt-6">
          <input
            #fileInput
            type="file"
            (change)="onFileChange($event)"
            [disabled]="isUploading"
            class="block w-full text-[16px] text-gray-700 file:py-1 file:px-4 file:border-1 file:border-dc-navy file:text-dc-black file:bg-[#E5EBEF] hover:file:bg-primary"
          />
        </div>

        @if (validationError == "DOCUMENTS.SELECT_STAMP_LOCATION") {
          <div class="fields-error-container">
            {{ "DOCUMENTS.SELECT_STAMP_LOCATION" | translate }}
          </div>
        } @else if (validationError || isDocumentsMissing) {
          <div class="fields-error-container">
            {{ validationError | translate }}
            @if (isDocumentsMissing) {
              {{ "DOCUMENTS.FILE_REQUIRED" | translate }}
            }
          </div>
        }
      </div>
    }
  </div>
}
